<template name="koList">
  <div class="ko-list">
    <div class="ko-list-header" :class="{ 'show-mask': isPickedShown && pickedKOList.length }">
      <div class="inner" v-if="!isSingleSelect">
        <div class="row">
          <div class="col-1">
            <img src="../assets/images/arrow-back.png" alt="back" @click="changeKO(true)" class="arrow-back">
          </div>
          <div class="col-9">
            <i class="iconfont icon-search"></i>
            <input type="" name="" class="form-control" :placeholder="$t('searchCondition')" v-model="keywords" @focus="focusOrBlur"
             @blur="focusOrBlur">
            <img src="../assets/images/close-b@2x.png" alt="" class="clear-input"
              @click="clearInput" v-show="keywords.trim().length">
          </div>
          <div class="search-btn">
            <button class="btn" :class="{ searchable: keywords.trim() }"
            @click="getKOList(true)" :disabled="!keywords.trim()">{{ $t('Search') }}</button>
          </div>
        </div>
      </div>
      <div v-else class="select-single-ko">
        <div class="col-1">
          <img src="../assets/images/arrow-back.png" alt="back" @click="changeKO(true)" class="arrow-back">
        </div>
        {{ $t('SelectInternalVisitor') }}
      </div>
    </div>
    <div class="ko-list-content" v-infinite-scroll="getKOList" infinite-scroll-disabled="isLoading"
    infinite-scroll-distance="200" infinite-scroll-immediate-check="true">
      <div class="no-data" v-show="!koList.length && searched">
        {{$t('NoSearchResult')}}
      </div>
      <div class="inner">
        <div class="row" v-for="(user , idx) in koList" :key="idx">
          <div class="col-10">
            <img class="head-portrait" :id="user.id" :src="user.avatar || defaultAvatar">
            <span>{{ user.userName }}<span v-show="user.deptName">({{ user.deptName }})</span></span>
          </div>
          <div class="col-2">
            <span class="check-item" :class="{ checked: user.checked, radio: isSingleSelect }"
            @click="toggleUser(user.id)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="ko-list-picked" v-show="isPickedShown && pickedKOList.length"  v-if="!isSingleSelect">
      <div class="inner">
        <div class="ko-list-picked-header">{{$t('SelectedKO')}}</div>
        <div>
          <div class="row" v-for="(user, idx) in pickedKOList" :key="idx">
            <div class="col-10">
              <img class="head-portrait" :src="user.avatar">
              <span>{{ user.userName }}({{ user.deptName || user.email || user.phoneNumber }})</span>
            </div>
            <div class="col-2">
              <span class="check-item" @click="toggleUser(user.id)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ko-list-footer" v-show="isFooterShown">
      <div class="inner" v-if="!isSingleSelect">
        <div class="row">
          <div class="col-5">{{$t('Selectedpeople')}}<strong>{{ pickedKOList.length }}</strong>{{$t('people')}}</div>
          <div class="col-3" @click="showPicked">{{$t('Detail')}}<i class="iconfont icon-down"
          :class="{ 'icon-up': isPickedShown && pickedKOList.length }"></i></div>
          <div class="col-4">
            <button class="btn btn-gradient" @click="changeKO(false)">{{$t('SubmitSelection')}}</button>
          </div>
        </div>
      </div>
      <div v-else class="submit-ko">
        <div class="col-12">
          <button class="btn btn-gradient" @click="changeKO(false)">{{ $t('submit') }}</button>
        </div>
      </div>
    </div>
    <alertModal
      modalType="simple"
      :isModalShown="isConfirmShown"
      :modalTitle="$t('PleaseselectKO')"
      @cancel="isConfirmShown = false"
    >
    </alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import { getKOByKeywords } from '@/utils/api';
import { checkNested } from '@/utils/utils';
// https://github.com/ankurk91/vue-loading-overlay
// https://github.com/ElemeFE/vue-infinite-scroll
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import infiniteScroll from 'vue-infinite-scroll';
import alertModal from '@/components/alertModal.vue';

Vue.use(infiniteScroll);
const MobileDetect = require('mobile-detect');

const md = new MobileDetect(window.navigator.userAgent);
const isPhone = !!md.phone();
const winHeight = window.innerHeight;

export default {
  name: 'koList',
  props: {
    isSingleSelect: Boolean,
    koListItem: Array,
  },
  data() {
    return {
      keywords: '',
      pageIndex: 1,
      pageCount: 50,
      totalPages: 0,
      isAllLoaded: false,
      koList: [],
      searched: false,
      pickedKOList: [],
      isPickedShown: false,
      isConfirmShown: false,
      isFooterShown: true,
      isLoading: false,
      defaultAvatar: require('../assets/images/default-avatar.png'),
    };
  },
  components: {
    Loading,
    alertModal,
  },
  watch: {
    koListItem(newArr) {
      this.koList = newArr.map(x => ({ ...x, checked: false }));
    },
  },
  created() {
    const { isSingleSelect, koListItem } = this.$props;
    if (isSingleSelect && koListItem && koListItem.length) {
      this.koList = koListItem.map(x => ({ ...x }));
    }
  },
  methods: {
    changeKO(isBack) {
      const { isSingleSelect } = this.$props;
      this.pickedKOList = isSingleSelect && !isBack ? this.koList.filter(x => x.checked) : this.pickedKOList;
      if (!this.pickedKOList.length && !isBack) { // show confirm modal for submit(select nothing)
        this.isConfirmShown = true;
      } else {
        this.$emit('koStatus', this.pickedKOList);
        this.koList = this.$props.isSingleSelect ? this.koList.map(x => ({ ...x, checked: false })) : [];
        this.pickedKOList = [];
        this.searched = false;
        this.keywords = '';
        this.pageIndex = 1;
        this.isPickedShown = false;
      }
    },
    clearInput() {
      this.keywords = '';
    },
    getKOList(isFresh) {
      const keywords = this.keywords.trim();
      if (isFresh) {
        this.pageIndex = 1;
        this.koList = [];
        this.isAllLoaded = false;
        this.searched = false;
      }
      if (keywords && !this.isAllLoaded) {
        this.isLoading = true;
        getKOByKeywords(this.pageIndex, this.pageCount, keywords).then((res) => {
          this.isLoading = false;
          if (checkNested(res, 'data', 'content', 'model', 'entities')) {
            this.koList = [...this.koList, ...res.data.content.model.entities];
            this.koList.forEach((x) => { x.checked = false; x.trackId = 0; });
            this.searched = true;
            this.totalPages = res.data.content.model.totalPages;
            this.isAllLoaded = this.pageIndex === this.totalPages;

            this.pageIndex = this.pageIndex < this.totalPages
              ? this.pageIndex + 1 : this.totalPages;
          }
        });
      }
    },
    toggleUser(id) {
      const { koList } = this;
      const user = koList.find(x => x.id === id); // current searched result, may not contain user in picked list
      const { isSingleSelect } = this.$props;
      if (isSingleSelect) {
        this.koList = this.koList.map(x => ({ ...x, checked: x.id === id }));
        this.pickedKOList = this.koList.filter(x => x.checked);
      } else {
        if (user) {
          user.checked = !user.checked;
        }
        this.koList = koList;
        const duplicatedRemovedList = this.koList.filter(x => x.checked && this.pickedKOList.findIndex(y => y.id === x.id) === -1);
        this.pickedKOList = (user && user.checked) ? [...this.pickedKOList, ...duplicatedRemovedList]
          : this.pickedKOList.filter(x => x.id !== id);
        this.isPickedShown = this.isPickedShown && this.pickedKOList.length;
      }
    },
    showPicked() {
      this.isPickedShown = this.pickedKOList.length ? !this.isPickedShown : this.isPickedShown;
    },
    focusOrBlur() {
      const delay = 100;
      if (isPhone) {
        const timerId = setInterval(() => {
          const currentWinHeight = window.innerHeight;
          if ((winHeight - currentWinHeight) > 50) {
            this.isFooterShown = false;
          // clearInterval(timerId);
          } else {
            this.isFooterShown = true;
          // clearInterval(timerId);
          }
        }, delay);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.ko-list {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: #fff;
  top: 0;
  left: 0;
}
.ko-list-content {
  position: absolute;
  left: 0;
  top: 56px;
  bottom: 56px;
  overflow: auto;
  width: 100%;
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #929292;
    font-weight: bold;
    padding-top: 40px;
  }
  & > div {
    padding: 0;
    width: 90%;
    margin: auto;
    .row {
      margin: 0;
      padding-top: 16px;
      padding-bottom: 12px;
      align-items: center;
      border-bottom: 1px solid #f0f1f2;
      div {
        padding: 0;
        // font-family: HiraginoSansGB-W3;
        font-size: 13px;
        color: #4a4a4a;
        img.head-portrait {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 16px;
        }
        .check-item {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url('../assets/images/copy-14.png');
          background-size: contain;
          border-radius: 50%;
          &.checked {
            background-image: url('../assets/images/xuanzhong-copy-6.png');
            &.radio {
             background-image: none;
             border: 2px solid #e42029;
             position: relative;
             &::before {
              content: '';
              display: block;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #e42029;
              top: 4px;
              left: 4px;
              position: absolute;
             }
            }
          }
        }
      }
      & > div:nth-of-type(2) {
        text-align: right;
        padding-right: 10px;
      }
    }
  }
}
.ko-list-picked {
  @extend .ko-list-content;
  background: rgba(0,0,0,.4);
  .ko-list-picked-header {
    font-size: 14px;
    text-align: center;
    color: #4a4a4a;
    font-weight: bold;
    line-height: 38px;
    border-bottom: 1px solid #f0f1f2;
  }
  .inner {
    background: #fff;
    position: absolute;
    bottom: 0;
    width: 100%;
    & > div {
      max-height: 266px;
      overflow: auto;
      .row {
        width: 90%;
        margin: auto;
        padding: 6px 0;
        .check-item {
          background-image: url('../assets/images/2-copy-12@2x.png');
        }
      }
    }
  }
}
.ko-list-header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  box-shadow: 0 0 15px rgba(100,100,100,.2);
  .col-12 {
    position: relative;
  }
  i {
    position: absolute;
    top: 0;
    left: 25px;
    line-height: 36px;
    color: #999;
    font-size: 18px;
  }
  .inner {
    width: 90%;
    padding: 10px 0;
    margin: 0 auto;
  }
  .form-control {
    height: 36px;
    border-radius: 18px;
    border: 0;
    font-size: 14px;
    padding: 11px 20px 11px 36px;
    background: #f1f1f1;
  }
  .clear-input {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 8px;
  }
  .col-1 {
    display: flex;
    align-items: center;
    img {
      width: 18px;
    }
  }
  .col-9 {
    position: relative;
    padding-right: 0;
  }
  .search-btn {
    color: #4a4a4a;
    font-size: 14px;
    padding: 0;
    position: absolute;
    right: 5px;
    .btn {
      border: 0;
      font-size: 14px;
      color: #929292;
      &.searchable {
        color: #e42029;
      }
    }
  }
  &.show-mask:after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
  }
  .select-single-ko {
    display: flex;
    line-height: 56px;
  }
}
.ko-list-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  line-height: 36px;
  box-shadow: 0 0 15px rgba(100,100,100,.2);
  .submit-ko {
    padding-bottom: 1em;
  }
  .inner {
    width: 90%;
    padding: 10px 0;
    margin: 0 auto;
  }
  .btn {
    font-size: 15px;
    display: block;
    width: 100%;
  }
  .col-5 {
    font-size: 14px;
    color: #929292;
    strong {
      font-size: 16px;
      color: #e42029;
      padding: 0 5px;
    }
  }
  .col-3 {
    font-size: 12px;
    color: #4a4a4a;
    text-align: right;
    padding-right: 0;
    i {
      font-size: 12px;
      transform: scale(0.6,0.6);
      display: inline-block;
    }
  }
}
</style>
